module.exports = __webpack_public_path__ + "img/IMG_8964.690e76f9.jpg";